import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import useI18n from "../hooks/useI18n";
import useReloader from "../hooks/useReloader";

const MenuLocaleSelect = () => {
    const { getLocale, getLanguages, setLocale, getLanguageLabel } = useI18n();
    const [currentLocale, setCurrentLocale] = useState(getLocale());
    const { reload } = useReloader();

    /**
     * Switch the language and reload the page.
     * @param {string} locale
     */
    const switchLang = (locale) => {
        setCurrentLocale(locale);
        setLocale(locale);
        reload();
    }

    return (
        <Dropdown className="locale-select">
            <Dropdown.Toggle className="actionlist-button" variant='tertiary-menu'>
                {getLanguageLabel(currentLocale)}
            </Dropdown.Toggle>
            <Dropdown.Menu className="custom-locale-menu">
                {getLanguages().map(locale => (
                    <Dropdown.Item
                        key={locale}
                        className={'dropdown-check-item' + (locale === currentLocale ? ' active' : '')}
                        onClick={() => { switchLang(locale); }}
                    >
                        {getLanguageLabel(locale)}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default MenuLocaleSelect;
